import { PRODUCT_FEATURES } from '@shared/constants/product-features.constants';

/**
 * Utility functions for checking product features
 */

export function isReverseMortgage(
  features: string[] | { value?: string[] } | null | undefined
): boolean {
  if (!features) {
    return false;
  }

  // Handle OpportunityPropertyDefinition case
  if (typeof features === 'object' && 'value' in features) {
    return !!(features as { value?: string[] }).value?.includes(
      PRODUCT_FEATURES.REVERSE_MORTGAGE
    );
  }

  // Handle regular array case
  return !!(features as string[]).includes(PRODUCT_FEATURES.REVERSE_MORTGAGE);
}

export function hasInterestCapitalised(
  features: string[] | { value?: string[] } | null | undefined
): boolean {
  if (!features) {
    return false;
  }

  // Handle OpportunityPropertyDefinition case
  if (typeof features === 'object' && 'value' in features) {
    return !!(features as { value?: string[] }).value?.includes(
      PRODUCT_FEATURES.INTEREST_CAPITALISED
    );
  }

  // Handle regular array case
  return !!(features as string[]).includes(
    PRODUCT_FEATURES.INTEREST_CAPITALISED
  );
}

export function isBridgingProduct(
  features: string[] | { value?: string[] } | null | undefined
): boolean {
  if (!features) {
    return false;
  }

  // Handle OpportunityPropertyDefinition case
  if (typeof features === 'object' && 'value' in features) {
    return !!(features as { value?: string[] }).value?.includes(
      PRODUCT_FEATURES.BRIDGING
    );
  }

  // Handle regular array case
  return !!(features as string[]).includes(PRODUCT_FEATURES.BRIDGING);
}


// Checks if a product selection (single or package) contains any reverse mortgage products
export function isReverseMortgageSelection(productSelection: any): boolean {
  if (!productSelection) {
    return false;
  }

  // Check if it's a package product
  if (productSelection.packageProduct?.products) {
    return productSelection.packageProduct.products.some(
      (packageProduct: any) =>
        isReverseMortgage(packageProduct.product?.features)
    );
  }

  // Check if it's a single product
  if (productSelection.singleProduct?.features) {
    return isReverseMortgage(productSelection.singleProduct.features);
  }

  return false;
}
